import React, { Component } from "react";
import "./settings.styles.css";
import UserSettingsTabs from "./UserSettingsTabs/UserSettingsTabs.component";
import ModulesHeaderImg from "./../../../assets/Img/Modules/modules-header-img.svg";
export default class Settings extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <>
        <header className="settingsHeaderContainer">
          <h1 className="heroTitle">Settings</h1>
          <img
            src={ModulesHeaderImg}
            alt="dashboard modules graphic"
            className="modules-header-img"
          />
        </header>

        <UserSettingsTabs />
      </>
    );
  }
}
